export const NIR_LENGTH = 15

const NIR_GROUPS = [1, 2, 2, 2, 3, 3, 2]

export const NIR_INCOMPLETE_ERROR = 'Le numéro de sécurité sociale doit contenir 15 caractères.'
export const NIR_INVALID_ERROR = 'Le numéro de sécurité sociale est invalide. Vérifiez votre saisie.'

// Corsica is the only place a letter is legal in a NIR: département 2A/2B at positions 6-7.
// The letter is kept as printed on the Vitale card, so such a NIR gets no contrôle-key check.
const CORSICA_DEPARTMENTS = ['2A', '2B']

function normalize(value: string): string {
  let out = ''
  for (const char of value.toUpperCase()) {
    if (out.length >= NIR_LENGTH) break
    const corsicanLetter = out.length === 6 && out[5] === '2' && (char === 'A' || char === 'B')
    if (/\d/.test(char) || corsicanLetter) out += char
  }
  return out
}

export function formatNirInput(value: string): string {
  const digits = normalize(value)
  let cursor = 0
  const parts: string[] = []

  for (const size of NIR_GROUPS) {
    if (cursor >= digits.length) break
    parts.push(digits.slice(cursor, cursor + size))
    cursor += size
  }

  return parts.join(' ')
}

export function extractNirDigits(value: string): string {
  return normalize(value)
}

export function isValidNir(value: string): boolean {
  const digits = normalize(value)
  if (digits.length !== NIR_LENGTH) return false
  if (CORSICA_DEPARTMENTS.includes(digits.slice(5, 7))) return true

  // Contrôle key printed on the Vitale card: 97 - (first 13 digits mod 97).
  const expectedKey = 97 - (Number(digits.slice(0, 13)) % 97)

  return expectedKey === Number(digits.slice(13, 15))
}

export function getNirError(value: string): string | null {
  const digits = normalize(value)
  if (digits.length === 0) return null
  if (digits.length !== NIR_LENGTH) return NIR_INCOMPLETE_ERROR
  return isValidNir(digits) ? null : NIR_INVALID_ERROR
}
